
import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import { Position } from '../types/portfolio';

interface AllocationChartProps {
  positions: Position[];
}

export function AllocationChart({ positions }: AllocationChartProps) {
  // Mock sector data since Alpaca positions don't have sector by default
  const sectorMap: Record<string, string> = {
    'NVDA': 'Technology',
    'TSLA': 'Consumer Cyclical',
    'AAPL': 'Technology',
    'MSFT': 'Technology',
    'AMZN': 'Consumer Cyclical',
  };

  const allocationData = positions.reduce((acc: any[], pos) => {
    const sector = sectorMap[pos.symbol] || 'Other';
    const value = parseFloat(pos.market_value);
    const existing = acc.find(item => item.name === sector);
    if (existing) {
      existing.value += value;
    } else {
      acc.push({ name: sector, value });
    }
    return acc;
  }, []);

  const COLORS = ['#10b981', '#3b82f6', '#f59e0b', '#8b5cf6', '#ec4899', '#64748b'];

  return (
    <div className="bg-[var(--card-bg)] border border-[var(--card-border)] rounded-2xl overflow-hidden shadow-sm flex flex-col h-full">
      <div className="p-4 border-b border-[var(--card-border)] bg-[var(--card-header-bg)]">
        <h3 className="text-sm font-black text-[var(--app-text)] uppercase tracking-tight italic">Sector Allocation</h3>
      </div>
      
      <div className="flex-1 p-4 min-h-[300px]">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={allocationData}
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={80}
              paddingAngle={5}
              dataKey="value"
              animationDuration={1000}
            >
              {allocationData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip 
              contentStyle={{ 
                backgroundColor: 'var(--slate-900)', 
                border: 'none', 
                borderRadius: '8px',
                fontSize: '12px',
                color: '#fff'
              }}
              itemStyle={{ color: '#fff' }}
              formatter={(value: number) => [`$${value.toLocaleString()}`, 'Value']}
            />
            <Legend 
              verticalAlign="bottom" 
              height={36}
              formatter={(value) => <span className="text-[10px] font-bold text-[var(--muted-text)] uppercase tracking-widest">{value}</span>}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
